import { render, staticRenderFns } from "./OrderDeliveryFields.vue?vue&type=template&id=ea0f1e94&"
import script from "./OrderDeliveryFields.vue?vue&type=script&lang=js&"
export * from "./OrderDeliveryFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports